<template>
  <q-form ref="formRef" greedy>
    <div class="text-h5 text-bold">バブル</div>
    <div class="text-subtitle2">コンテナータイプ：バブルの設定</div>
    <div class="row q-mt-md">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>タイプ<span class="text-brand-red">*</span></div>
        <div class="text-caption">Type</div>
      </div>
      <q-select
        outlined
        dense
        emit-value
        map-options
        v-model="value.type"
        :options="typeList"
        class="col"
        disable
      >
        <template v-slot:selected-item="scope">
          <div class="column">
            <div>{{ scope.opt.label }}</div>
            <div class="text-caption">{{ scope.opt.value }}</div>
          </div>
        </template>
      </q-select>
    </div>
    <div class="row q-mt-sm" v-if="isParent">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>代替テキスト<span class="text-brand-red">*</span></div>
        <div class="text-caption">altText</div>
      </div>
      <q-input
        outlined
        dense
        lazy-rules
        v-model="currentAltText"
        :rules="[(val) => (val && val.length > 0) || requiredRule.altText]"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>配置</div>
        <div class="text-caption">Direction</div>
      </div>
      <q-select
        outlined
        dense
        emit-value
        map-options
        v-model="value.direction"
        :options="directionList"
        class="col"
      >
        <template v-slot:selected-item="scope">
          <div class="column">
            <div>{{ scope.opt.label }}</div>
            <div class="text-caption">{{ scope.opt.value }}</div>
          </div>
        </template>
      </q-select>
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>サイズ</div>
        <div class="text-caption">Size</div>
      </div>
      <q-select
        outlined
        dense
        v-model="value.size"
        :options="sizeList"
        class="col"
      />
    </div>
    <q-separator class="q-my-md" v-if="isAdmin" />
    <Action v-model="value.action" v-if="isAdmin" />
  </q-form>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageBubble, IFlexMessageURIAction } from '@/utils/types'
import Action from '@/components/common/flex-message/forms/Action.vue'

@Options({
  components: { Action },
  directives: { maska },
  emits: ['update:modelValue', 'update:altText', 'update:validateValue'],
})
export default class Bubble extends Vue {
  @Prop()
  modelValue!: IFlexMessageBubble

  @Prop()
  altText!: string

  @Prop()
  isParent!: boolean

  @Prop()
  isAdmin!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble) {
    this.$emit('update:modelValue', value)
  }

  get currentAltText() {
    return this.altText
  }

  set currentAltText(value: string) {
    this.$emit('update:altText', value)
  }

  get requiredRule() {
    return {
      altText: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.answer.alt_text'),
      }),
    }
  }

  get directionList() {
    return [
      {
        label: '左寄せ',
        value: 'ltr',
      },
      {
        label: '右寄せ',
        value: 'rtl',
      },
    ]
  }

  get typeList() {
    return [
      {
        label: 'カルーセル',
        value: 'carousel',
      },
      {
        label: 'バブル',
        value: 'bubble',
      },
    ]
  }

  get sizeList() {
    return ['giga', 'mega', 'kilo', 'hecto', 'deca', 'micro', 'nano']
  }

  @Watch('currentAltText')
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    if (this.value.action) {
      if (this.value.action.type === 'uri') {
        const uriAction: IFlexMessageURIAction = {
          type: 'uri',
          label: 'action',
          uri: 'http://linecorp.com/',
          altUri: {
            desktop: '',
          },
        }
        this.value.action = { ...uriAction, ...this.value.action }
      }
    }
    this.validate()
  }
}
</script>

<style scoped lang="scss">

</style>
